

export default async () => {
	/*-------- Header --------*/
	const { default: Header } = await import('@components/header')

	const header = new Header(document.querySelector('.header'))

	addEventListener('opening', e => {
		if (e.target.matches('.menu-wrapper, .submenu')) {
			header.offset = header.element.offsetHeight
		}
	})


	/*-------- Menu --------*/
	const menuWrapper = document.querySelector('.menu-wrapper')
	const menuToggle = document.querySelector('.menu-toggle')

	if (menuWrapper && menuToggle) {
		const { default: Menu } = await import('@components/menu')

		new Menu(menuWrapper, menuToggle)
	}

	/*-------- Submenus --------*/
	const submenus = document.querySelectorAll('.submenu')

	if (submenus.length) {
		const { default: Submenu } = await import('@components/submenus')

		submenus.forEach(submenu => new Submenu(submenu, submenu.previousElementSibling))

		addEventListener('opening', e => {
			if (e.target.classList.contains('submenu')) {
				document.body.style.setProperty('--submenu-h', `${e.target.offsetHeight}px`)
			}
		})

		addEventListener('closing', e => {
			if (e.target.classList.contains('submenu')) {
				document.body.style.setProperty('--submenu-h', '')
			}
		})
	}

	/*-------- Modals --------*/
	const { default: Overlay } = await import('@components/overlays')

	document.querySelectorAll('.modal').forEach(item => new Overlay(item))



	/*-------- Language toggle --------*/  
	document.querySelectorAll('.language-toggle, .language-menu .arrow-svg').forEach(function (element) {
		element.addEventListener('click', function () {
			var menu = this.closest('.language-menu');
			if (!menu) return;
	
			var toggle = menu.querySelector('.language-toggle');
			var list = menu.querySelector('.language-list');
			var arrow = menu.querySelector('.language-menu .arrow-svg');
	
			if (toggle) {
				toggle.classList.toggle('active');
				var ariaExpanded = toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';
				toggle.setAttribute('aria-expanded', ariaExpanded);
			}
	
			if (list) {
				if (list.style.display === 'flex') {
					list.style.display = 'none';
				} else {
					list.style.display = 'flex';
				}
			}
	
			if (arrow) {
				arrow.classList.toggle('active');
			}
		});
	});
	


}